import { useNavigate, useParams } from 'react-router-dom'
import { Button } from '../../../components/Button/Button'
import React from 'react'

export const FormTemplateViewHeader = () => {
  const navigate = useNavigate()
  const { formId = '' } = useParams()

  const handleBackButtonClicked = () => {
    navigate(`/workspace/setup/forms/form/details/${formId}/templates`)
  }

  return (
    <div className='zocks-pl-2.0'>
      <Button variant='link' className='back-button' onClick={handleBackButtonClicked}>
        <i className='bi bi-chevron-left' />
      </Button>
    </div>
  )
}
